import ConfirmModificationFormComponent from "../../components/post-signature/ConfirmModificationFormComponent";



export default function ConfirmModificationBloc() {

      return (
        <div className="">
          <div className="">
            <ConfirmModificationFormComponent />
          </div>
        </div>
      )
}